<template>
    <div>

        <!--<div class="form-group mb-0">
            <select class="form-control custom-select">
                <option selected="">Alle Kalender anzeigen</option>
            </select>
        </div>-->

        <FullCalendar :options="calendarOptions" :event-sources="calendarOptions.events" />

        <!-- Create Modal -->
        <div class="modal fade" id="modal-create-package" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <div v-if="selectedEventType == 0">
                                <span v-if="!editEvent">Neuer Buchungsslot</span><span v-else>Buchungsslot bearbeiten</span>
                            </div>
                            <div v-else>
                                <span v-if="!editEvent">Neue Buchung</span><span v-else>Buchung bearbeiten</span>
                            </div>
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    </div>

                    <div class="modal-body">

                        <div v-if="selectedEventType == 1" class="bg-soft-info p-2">
                            <strong>Buchungsdaten</strong>
                            <p><small v-html="selectedBookingData"></small></p>
                        </div>

                        <div class="form-group">
                            <label class="col-form-label col-form-label-md"><span v-if="selectedDateEnd">Von </span>Datum:</label>
                            <input type="date" v-model="selectedDateStart" class="form-control form-control-sm">
                        </div>
                        <div class="form-group" v-if="selectedDateEnd">
                            <label class="col-form-label col-form-label-md">Bis Datum:</label>
                            <input type="date" v-model="selectedDateEnd" class="form-control form-control-sm">
                        </div>
                        <div class="form-group">
                            <label class="col-form-label col-form-label-md">Uhrzeit<span v-if="!selectedService"> von:</span></label>
                            <input type="time" v-model="selectedTimeStart" class="form-control form-control-sm">
                        </div>
                        <div v-if="!selectedService">
                            <div class="form-group">
                                <label class="col-form-label col-form-label-md">Uhrzeit bis:</label>
                                <input type="time" v-model="selectedTimeEnd" class="form-control form-control-sm">
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="col-form-label col-form-label-md">Buchungsstatus ändern:</label>
                            <select class="form-control" v-model="selectedStatus">
                                <option value="requested">Angefragt</option>
                                <option value="confirmed">Bestätigt</option>
                                <option value="completed">Abgeschlossen</option>
                            </select>
                        </div>

                        <div v-if="selectedStatus == 'confirmed'">
                            <div class="form-check form-group">
                                <input type="checkbox" v-model="checkConfirmationSMS" class="form-check-input" id="checkConfirmationSMS">
                                <label class="form-check-label col-form-label-m" for="checkConfirmationSMS">Bestätigungs-<strong>SMS</strong> senden</label>
                                <input type="phone" v-model="phone" class="form-control form-control-sm">
                                <textarea v-model="smsContent" class="form-control"></textarea>
                            </div>
                            <div class="form-check form-group">
                                <input type="checkbox" v-model="checkConfirmationEmail"  class="form-check-input" id="checkConfirmationEmail">
                                <label class="form-check-label col-form-label-m" for="checkConfirmationEmail">Bestätigungs-<strong>E-Mail</strong> senden</label>
                                <input type="email" v-model="email" class="form-control form-control-sm">
                                <textarea v-model="emailContent" class="form-control"></textarea>
                            </div>
                        </div>

                        <div v-if="selectedStatus == 'completed'">
                            <div class="form-check form-group">
                                <input type="checkbox" v-model="checkCompletedSMS" class="form-check-input" id="checkCompletedSMS">
                                <label class="form-check-label col-form-label-m" for="checkCompletedSMS">Abgeschlossen-<strong>SMS</strong> senden</label>
                                <input type="phone" v-model="phone" class="form-control form-control-sm">
                                <textarea v-model="smsContentCompleted" class="form-control"></textarea>
                            </div>
                            <div class="form-check form-group">
                                <input type="checkbox" v-model="checkCompletedEmail"  class="form-check-input" id="checkCompletedEmail">
                                <label class="form-check-label col-form-label-m" for="checkCompletedEmail">Abgeschlossen-<strong>E-Mail</strong> senden</label>
                                <input type="email" v-model="email" class="form-control form-control-sm">
                                <textarea v-model="emailContentCompleted" class="form-control"></textarea>
                            </div>
                        </div>

                    </div> <!-- /.modal-body -->

                    <!-- Modal Actions -->
                    <div class="modal-footer">
                        <button v-if="editEvent && selectedEventType == 0" type="button" class="btn btn-outline" style="flex-grow:1;flex-flow:column;" @click="deleteEvent(editEvent)"><span v-if="selectedEventType == 0">Slot</span><span v-else>Buchung</span> löschen</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Abbrechen</button>
                        <button id="buttonSavePackage" type="button" class="btn btn-primary" @click="saveEvent()">Speichern</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import listPlugin from '@fullcalendar/list';

export default {
    
    components: {
        FullCalendar // make the <FullCalendar> tag available
    },

    data() {
        return {
            calendarOptions: {
                plugins: [ listPlugin ],
                initialView: 'listWeek',
                locale: 'de',
                views: {
                    listDay: { buttonText: 'Tag' },
                    listWeek: { buttonText: 'Woche' },
                    listMonth: { buttonText: 'Monat' }
                },
                headerToolbar: {
                    left: 'title',
                    center: '',
                    right: 'prev,next,listDay,listWeek,listMonth'
                },
                events: '/api/timeline/events/'+ this.storeId +'?list&api_token='+this.apiToken,
                eventClick: this.handleEventClick,
                noEventsContent: 'Leider wurden keine Termine gefunden.',
            },
            selectedDateStart: '',
            selectedDateEnd: '',
            selectedTimeStart: '',
            selectedTimeEnd: '',
            selectedService: '',
            selectedEventType: 0,
            selectedStatus: '',
            selectedBookingData: '',
            editEvent: false,
            checkConfirmationSMS: false,
            checkConfirmationEmail: false,
            checkCompletedSMS: false,
            checkCompletedEmail: false,
            phone: '',
            email: '',
            smsContent: '',
            emailContent: '',
            smsContentCompleted: '',
            emailContentCompleted: '',
        }
    },

    created() {
        //this.getEvents();
    },

    methods: {

        getEvents() {

            var _this = this;
            axios.get('/api/timeline/events/'+ this.storeId +'?list&api_token='+this.apiToken)
            .then(function (response) {
                _this.calendarOptions.events = response.data;
            });

        },

        handleDateClick: function(arg) {
            //alert('date click! ' + arg.dateStr)
            //$('#modal-create-package').modal('show');
            //console.log(arg);
            //console.log(arg.dateStr);
            //this.clickedDate = arg.dateStr;
        },

        handleEventClick(clickInfo) {
            //if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
            //  clickInfo.event.remove()
            // }
            //console.log(clickInfo.event.end);
            //console.log(clickInfo.event.startStr);
            //console.log(clickInfo.event._def.publicId);
            //console.log(clickInfo.event.extendedProps.event_type);

            if(clickInfo.event._def.publicId) {
                //alert("Click auf freier Buchungsslot");
                //this.selectedEventType = 0;
                //this.selectedBookingData = '';
            //}
            //else { // click auf buchung
                this.selectedEventType = 1;
                // buchungsdaten laden
                var _this = this;
                axios.get('/api/booking/'+clickInfo.event._def.publicId+'?api_token='+this.apiToken)
                .then(function (response) {
                    console.log(response.data);
                    _this.selectedBookingData = response.data.bookingdata;
                    _this.phone = response.data.phone;
                    _this.email = response.data.email;
                    _this.smsContent = response.data.smsContent;
                    _this.emailContent = response.data.emailContent;
                    _this.smsContentCompleted = response.data.smsContentCompleted;
                    _this.emailContentCompleted = response.data.emailContentCompleted;
                });
                
            }

            this.editEvent = clickInfo.event.id;

            var m = '' + (clickInfo.event.start.getMonth() + 1),
            d = '' + clickInfo.event.start.getDate(),
            Y = clickInfo.event.start.getFullYear();
            if (m.length < 2) 
                m = '0' + m;
            if (d.length < 2) 
                d = '0' + d;
            this.selectedDateStart = Y + '-' + m + '-' + d;

            var hour = clickInfo.event.start.getHours();
            var min = clickInfo.event.start.getMinutes();
            if (hour < 10) 
                hour = '0' + hour;
            if (min < 10)
                min = '0' + min;
            this.selectedTimeStart = hour + ':' + min;

            var m = '' + (clickInfo.event.end.getMonth() + 1),
            d = '' + clickInfo.event.end.getDate(),
            Y = clickInfo.event.end.getFullYear();
            if (m.length < 2) 
                m = '0' + m;
            if (d.length < 2) 
                d = '0' + d;
            this.selectedDateEnd = Y + '-' + m + '-' + d;

            var hour = clickInfo.event.end.getHours();
            var min = clickInfo.event.end.getMinutes();
            if (hour < 10) 
                hour = '0' + hour;
            if (min < 10)
                min = '0' + min;
            this.selectedTimeEnd = hour + ':' + min;

            if(this.selectedDateStart == this.selectedDateEnd) {
                this.selectedDateEnd = false;
            }

            this.selectedService = clickInfo.event.extendedProps.service_id; // returns an id or 'null'

            this.selectedStatus = clickInfo.event.extendedProps.status;
            
            /*this.selectedDateStart = clickInfo.start;
            this.selectedDateStart = clickInfo.end;
            this.selectedTimeStart = false;
            this.selectedTimeEnd = false;
            this.selectedService = '';*/

            $('#modal-create-package').modal('show');
        },

        saveEvent() {

            if(this.checkCompletedSMS) {
                this.smsContent = this.smsContentCompleted;
            }
            if(this.checkCompletedEmail) {
                this.emailContent = this.emailContentCompleted;
            }

            var _this = this;
            var data = { startDate: this.selectedDateStart, endDate: this.selectedDateEnd, startTime: this.selectedTimeStart, endTime: this.selectedTimeEnd, service: this.selectedService, status: this.selectedStatus, editEvent: this.editEvent,
                checkConfirmationSMS: this.checkConfirmationSMS,
                checkConfirmationEmail: this.checkConfirmationEmail,
                phone: this.phone,
                email: this.email,
                smsContent: this.smsContent,
                emailContent: this.emailContent }

            axios.put('/api/booking/'+this.editEvent+'?api_token='+this.apiToken, data)
            .then(function (response) {
                console.log(response);
                if(_this.editEvent) {
                    // edit event
                    //_this.getEvents();
                }
            });
            $('#modal-create-package').modal('hide');
            this.getEvents();
        }

        /*deleteEvent(eventId) {
           
            var check = confirm('Wollen Sie den Eintrag wirklich löschen?'); 
            if (check) {

                var _this = this;

                axios
                .delete('/api/events/'+eventId+'?api_token='+this.apiToken)
                .then(function (response) {
                    $('#modal-create-package').modal('hide');
                    _this.getEvents();
                });

            }

        },*/
    },

    mounted() {
        console.log(this.calendarData);
        //this.slottype = this.calendarData.slottype;
        this.services = this.servicesData;
    },

    props: ['storeId', 'apiToken']

}
</script>